export default "__VITE_ASSET__C4p81qNB__"